import Swiper from "swiper";

export default function MediaSlider(container) {
    const self = this;
    const thumbnailsContainer = container.querySelector(".js-media-thumbnails-slider");
    const thumbnailsItems = thumbnailsContainer.querySelectorAll(".js-media-thumbnails-slide");
    // const thumbnailsNextButtonElement = container.querySelector(".js-media-thumbnails-slider-button-next");
    // const thumbnailsPreviousButtonElement = container.querySelector(".js-media-thumbnails-slider-button-prev");

    const sliderContainer = container.querySelector(".js-media-slider-block");
    const nextButtonElement = container.querySelector(".js-media-slider-button-next");
    const previousButtonElement = container.querySelector(".js-media-slider-button-prev");
    const paginationElement = container.querySelector(".js-media-slider-pagination");

    const thumbnailsSlider = new Swiper(thumbnailsContainer, {
        speed: 500,
        slidesPerView: "auto",
        slideClass: "js-media-thumbnails-slide",
        wrapperClass: "js-media-thumbnails-slider-wrapper"
    });

    window.addEventListener("load", function() {
        thumbnailsSlider.update();
        thumbnailsSlider.slideTo(0, 0);
    });

    const slider = new Swiper(sliderContainer, {
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        slidesPerView: 1,
        speed: 600,
        slideClass: "js-media-slide",
        wrapperClass: "js-media-slider-wrapper",
        navigation: {
            nextEl: nextButtonElement,
            prevEl: previousButtonElement,
        },
        pagination: {
            el: paginationElement,
            type: "fraction",
        }
    });

    slider.on("slideChange", slideChangeHandler);

    for (let i = 0, len = thumbnailsItems.length; i < len; i++) {
        initThumbnailsItem(thumbnailsItems[i], i);
    }


    function initThumbnailsItem(itemElement, index) {
        itemElement.addEventListener("click", function() {
            slider.slideToLoop(index);
        });
    }

    function setActiveThumbnail(thumbnailsItems, activeIndex) {
        for (let i = 0, len = thumbnailsItems.length; i < len; i++) {
            thumbnailsItems[i].classList.remove("is-active");
        }
        thumbnailsItems[activeIndex].classList.add("is-active");
    }

    function slideChangeHandler() {
        setActiveThumbnail(thumbnailsItems, this.realIndex);

        if (self.linkedSlider) {
            self.linkedSlider.removeChangeListener();
            self.linkedSlider.setActiveSlide(this.realIndex);
            self.linkedSlider.initChangeListener();
        }
    }

    this.updateSize = function() {
        slider.update();
        thumbnailsSlider.update();
    };

    this.setLinkedSlider = function(slider) {
        this.linkedSlider = slider;
    };

    this.initChangeListener = function() {
        slider.on("slideChange", slideChangeHandler);
    };

    this.removeChangeListener = function() {
        slider.off("slideChange", slideChangeHandler);
    };

    this.setActiveSlide = function(slideIndex) {
        slider.slideToLoop(slideIndex, false);
        setActiveThumbnail(thumbnailsItems, slideIndex);
    };
}